// extracted by mini-css-extract-plugin
export default {"modal-header":"GenerateJEModel_modal-header__qeoBJ","close-icon":"GenerateJEModel_close-icon__fZi9F","modal-body":"GenerateJEModel_modal-body__pV7Lz"};